module.exports = __webpack_public_path__ + "media/images/categories/carousel/companies-89229108d0363f369dd891ebb1b754c1.jpg";